<template lang="html">
    <div class="common-upload">
        <el-upload
            ref="upload"
            action="http://"
            :http-request="handleUpload"
            :show-file-list="false"
            :with-credentials="true"
            :accept="acceptType">
            <slot></slot>
        </el-upload>
        <common-confirm class="common-upload-confirm" iconColor="#e40030" :dialogVisiable.sync="importValidErrorVisible" :confirm="() => importValidErrorVisible = false" appendToDialog>
            <span v-html="importValidErrorMessage"></span>
        </common-confirm>
        <common-confirm class="common-upload-confirm" :dialogVisiable.sync="importValidUpdateVisible" :confirm="importExcel" appendToDialog>
            <div>有重复的记录，是否继续上传？</div>
        </common-confirm>
    </div>
</template>
<script>
    import common from '@/api/common';

  export default {
    props: {
        'importApi': {
            type: Object,
            required: true
        },
        'importType': {
            type: String,
            required: true,
            validator: function (value) {
                return ['Excel'].indexOf(value) !== -1
            }
        },
        'onSuccess': {
            type: Function,
            required: false            
        }
    },
    data() {
        return {
            importValidErrorVisible: false,
            importValidErrorMessage: '',
            importValidUpdateVisible: false,
            currentFile: null
        }
    },
    computed: {
        importUrl() {
            return this.importApi['importUrl4'+this.importType]();
        },
        importValidUrl() {
            return this.importApi['importValidUrl4'+this.importType]();
        },
        acceptType() {
            switch(this.importType) {
                case 'Excel':
                    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
                default:
                    return '';
            } 
        }
    },
    methods: {
        handleUpload() {
            this.currentFile = this.$refs.upload.uploadFiles[0].raw;
            this.$refs.upload.clearFiles();
            this.importApi['importValidUrl4'+this.importType]({file: this.currentFile })
                .then(res => {
                    if(res.errorMsg) {
                        this.importValidErrorMessage = ''
                        let errors = res.errorMsg.split('#');
                        errors.forEach(err => {
                            if(err) {
                                this.importValidErrorMessage += `<div class="error-msg">${err}</div>`
                            }
                        })
                        this.importValidErrorVisible = true;
                        return;
                    }

                    if(res.isUpdate) {
                        this.importValidUpdateVisible = true;
                        return;
                    }

                    this.importExcel();
                })
        },
        importExcel() {
            this.importApi['importUrl4'+this.importType]({file: this.currentFile })
                .then(res => {
                    if(this.onSuccess){
                        this.onSuccess();
                    }
                })
        }
    }
  };
</script>


// WEBPACK FOOTER //
// CommonUpload.vue?0d60ed55